import {
  GET_VOUCHER_FOLLOWUP_FAILURE,
  GET_VOUCHER_FOLLOWUP_REQUEST,
  GET_VOUCHER_FOLLOWUP_SUCCESS,
} from './eaDashboard.types';
import produce from 'immer';

const initialState = {
  voucherFollowUp: [],
  isLoadingVouchers: false,
  error: null,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    default:
      break;

    // Get Voucher Follow-up
    case GET_VOUCHER_FOLLOWUP_REQUEST:
      draft.isLoadingVouchers = true;
      draft.error = null;
      break;

    case GET_VOUCHER_FOLLOWUP_SUCCESS:
      draft.voucherFollowUp = action.response || [];
      draft.isLoadingVouchers = false;
      break;

    case GET_VOUCHER_FOLLOWUP_FAILURE:
      draft.isLoadingVouchers = false;
      draft.error = action.messages || ['Failed to load voucher follow-up'];
      break;
  }
  return draft;
}, initialState);
